import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash-es'
import { WebinarInfoPanelComponent, If } from '../../../sharedLegacy/components'
import { WaitingRoomCountdownComponent, ThankYouMessageComponent } from '..'
import { useWebinarColors } from '../../../sharedLegacy/hooks/useWebinarColors'

import './SimpleWaitingRoomScreenComponent.scss'
import './SimpleWaitingRoomScreenComponent.mobile.scss'

const renderInfoPanel = (liveData, isMobileDevice) => (
  <WebinarInfoPanelComponent
    liveData={liveData}
    theme="waiting-room"
    speakersSize={isMobileDevice ? 'small' : 'large'}
    style={{ color: '#FFFFFF' }}
  />
)

const renderThankYou = (liveData) => (
  <ThankYouMessageComponent liveData={liveData} />
)

const SimpleWaitingRoomScreenComponent = (props) => {
  const {
    liveData,
    webinarTimeEpoch,
    isWebinarTimeInThePast,
    onLiveCountdownZero,
    hasBeenBroadcasting,
    countdownEnabled,
    isWebinarOver,
    isMobileDevice,
  } = props

  const webinarColors = useWebinarColors()

  return (
    <div className="simple-waiting-room-screen-component">
      <div className="waiting-room-content">
        <If condition={countdownEnabled && !isWebinarOver}>
          <WaitingRoomCountdownComponent
            webinarTimeEpoch={webinarTimeEpoch}
            isWebinarTimeInThePast={isWebinarTimeInThePast}
            isHolding={hasBeenBroadcasting}
            onLiveCountdownZero={onLiveCountdownZero}
          />
        </If>
        <If condition={!isWebinarOver || isEmpty(liveData.after_webinar_link)}>
          <div
            className="decoration-line"
            style={{
              background: `linear-gradient(-90deg, rgb(30, 30, 30) 0%, ${webinarColors.accent} 100%)`,
            }}
          />
        </If>
        {isWebinarOver
          ? renderThankYou(liveData)
          : renderInfoPanel(liveData, isMobileDevice)}
      </div>
    </div>
  )
}

SimpleWaitingRoomScreenComponent.propTypes = {
  liveData: PropTypes.object,
  webinarTimeEpoch: PropTypes.number,
  isWebinarTimeInThePast: PropTypes.bool,
  hasBeenBroadcasting: PropTypes.bool,
  countdownEnabled: PropTypes.bool,
  onLiveCountdownZero: PropTypes.func,
  isWebinarOver: PropTypes.bool,
  isMobileDevice: PropTypes.bool,
}

export default SimpleWaitingRoomScreenComponent
